import React from 'react';
import { css } from '@emotion/css';
import { Loader, Notification } from 'is24-corecss';
import { useGetProductsStatus } from '../../../../../../apiHooks/productsStatus.hook';
import { DEPOSIT_SERVICE_STATUS } from '../../../../../../@types/deposit';
import ProductDescription from './ProductDescription';
import CustomerService from './CustomerService';
import PendingFrame from './PendingFrame';
import DepositStatusFrame from './DepositStatusFrame';
import DepositNotifications from './DepositNotifications';
import { useIntl } from '@/i18n';

const styles = {
  LoaderContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = () => {
  const { t } = useIntl();
  const { productsStatus } = useGetProductsStatus();
  const depositStatus = productsStatus?.deposit?.status;
  const contentMap = {
    [DEPOSIT_SERVICE_STATUS.NOT_ACTIVATED]: (
      <>
        <DepositNotifications />
        <ProductDescription />
      </>
    ),
    [DEPOSIT_SERVICE_STATUS.CANCELLED]: (
      <>
        <DepositNotifications />
        <ProductDescription />
      </>
    ),
    [DEPOSIT_SERVICE_STATUS.PRE_PENDING]: (
      <>
        <DepositNotifications />
        <PendingFrame />
        <CustomerService />
      </>
    ),
    [DEPOSIT_SERVICE_STATUS.PENDING]: (
      <>
        <DepositNotifications />
        <PendingFrame />
        <CustomerService />
      </>
    ),
    [DEPOSIT_SERVICE_STATUS.REJECTED]: (
      <>
        <DepositNotifications />
        <Notification
          title={t({
            id: 'benefits.deposit.modal.overview.rejectedStatus.headline',
            defaultMessage: 'Mietkautionsbürgschaft abgelehnt',
          })}
          type='error'
          message={t({
            id: 'benefits.deposit.modal.overview.rejectedStatus.message',
            defaultMessage: 'Dein Antrag wurde von der Allianz abgelehnt.',
          })}
        />
        <br />
        <ProductDescription />
      </>
    ),
    [DEPOSIT_SERVICE_STATUS.ACTIVATED]: (
      <>
        <DepositNotifications />
        <DepositStatusFrame state={productsStatus?.deposit as any} />
        <CustomerService />
      </>
    ),
  };

  if (!depositStatus) {
    return (
      <div className={styles.LoaderContainer}>
        <Loader />
      </div>
    );
  }
  const OverviewContentDOM = contentMap[depositStatus];
  return <div style={styles.overviewTab}>{OverviewContentDOM}</div>;
};

export default OverviewTab;
